import { render, staticRenderFns } from "./SignPatrocinium.vue?vue&type=template&id=882bc3c4&scoped=true&"
import script from "./SignPatrocinium.vue?vue&type=script&lang=js&"
export * from "./SignPatrocinium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882bc3c4",
  null
  
)

export default component.exports